import { buildTierBadgeId, parseTierBadgeId } from '~/boggle/config/badges/familyBadgeId'
import type { BoggleBadgeFamilyId } from '~/boggle/config/badges/familyTypes'

import type { BoggleEarnedBadge } from './evaluateRunBadges'

/** Keeps only the highest tier earned per family (safety net for run summary). */
export function collapseEarnedBadgesForDisplay(
  earned: readonly BoggleEarnedBadge[],
): BoggleEarnedBadge[] {
  const bestByFamily = new Map<BoggleBadgeFamilyId, BoggleEarnedBadge>()
  const flat: BoggleEarnedBadge[] = []

  for (const entry of earned) {
    const parsed = parseTierBadgeId(entry.badgeId)
    if (!parsed) {
      flat.push(entry)
      continue
    }
    const existing = bestByFamily.get(parsed.familyId)
    if (!existing || parsed.tierIndex > (parseTierBadgeId(existing.badgeId)?.tierIndex ?? 0)) {
      bestByFamily.set(parsed.familyId, entry)
    }
  }

  const collapsed = [...flat, ...bestByFamily.values()]
  collapsed.sort((a, b) => {
    if (a.earnedAtLedgerIndex !== b.earnedAtLedgerIndex) {
      return a.earnedAtLedgerIndex - b.earnedAtLedgerIndex
    }
    return a.earnedAtMs - b.earnedAtMs
  })
  return collapsed
}

export function getLowerTierBadgeIds(
  familyId: BoggleBadgeFamilyId,
  tierIndex: number,
): string[] {
  const ids: string[] = []
  for (let tier = 1; tier < tierIndex; tier += 1) {
    ids.push(buildTierBadgeId(familyId, tier))
  }
  return ids
}
